var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpenses(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "60px",
    height: "60px",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    strokeWidth: 4.032,
    stroke: "#5d67ed",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#CCCCCC",
    strokeWidth: 0.128
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.36,41.21V52.14a2,2,0,0,1-2,2h-43a2,2,0,0,1-2-2v-31a2,2,0,0,1,2-2h43a2,2,0,0,1,2,2v8.93",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.64,
    y: 30.07,
    width: 18,
    height: 11.14,
    rx: 0.99,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.14,19.14l33.15-9.2h0a1.7,1.7,0,0,1,2.15,1.6l.27,7",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 45.73,
    y1: 35.64,
    x2: 46.26,
    y2: 35.64,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpenses);
export default __webpack_public_path__ + "static/media/expenses.86ca1ac3f75b9da2d4db04018f03a4e2.svg";
export { ForwardRef as ReactComponent };